import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CompanyListItem } from '../models/company-list.model';
import { delay } from 'rxjs/internal/operators';
import { CompanyDetail } from '../models/company-detail.model';
import { CompanyUpdate } from '../models/company-update.model';
import { CompanyNew } from '../models/company-new.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  apiUrl: string;
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.apiUrl = baseUrl + 'api/company';
  }

  get(params: HttpParams) {
    return this.httpClient.get<CompanyListItem[]>(this.apiUrl, { params: params, observe: 'response' });
      /*.pipe(
        delay(1000)
      );*/
  }

  getCompany(id: number) {
    const url = this.apiUrl + '/' + String(id);
    return this.httpClient.get<CompanyDetail>(url);
  }

  create(company: CompanyNew) {
    return this.httpClient.post(this.apiUrl, JSON.stringify(company), { headers: this.headers });
  }

  update(company: CompanyUpdate) {
    return this.httpClient.put(this.apiUrl, JSON.stringify(company), { headers: this.headers });
  }
}
